import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingInvoiceManualCreditEditComponent } from './billing-invoice-manual-credit-edit.component';
import { BillingInvoiceManualSharedModule } from '../billing-invoice-manual-shared.module';

@NgModule({
  declarations: [
    BillingInvoiceManualCreditEditComponent
  ],
  imports: [
    BillingInvoiceManualSharedModule
  ]
})
export class BillingInvoiceManualCreditEditModule { }
